<template>
    <div>
        <h4>Loading...</h4>
    </div>
</template>

<script>
    export default {
        mounted() {
            this.$nextTick(() => {
                this.$authService.setAccessToken()
                this.$authService.setIdToken()
                this.$router.push('/')

                //this.$emit('user-logged-in')
            })
        }
    }
</script>